import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
`;

export const OTPImageWrapper = styled.div`
    display: flex;
    margin-top: 30px;
`;

export const VerificationCodeText = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
    margin-top: 20px;
`;

export const OTPTextMessageWrapper = styled.div`
    display: flex;
`;

export const OTPTextMessage = styled.div`
    display: flex;
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const EditIcon = styled.div`
    display: flex;
    margin-left: 5px;
    align-items: center;
    margin-top: 5px;
`;

export const OTPInputWrapper = styled.div`
    display: flex;
    margin-top: 32px;
`;

export const ResendOTPText = styled.div`
    display: flex;
    margin-top: 22px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #5b5675;
`;

export const ResendLinkText = styled.div`
    display: flex;
    margin-top: 22px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #1b73e8;
`;
